(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["sha256-es"] = factory();
	else
		root["sha256-es"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*!
 * sha256-es
 * https://github.com/logotype/es-crypto.git
 *
 * Copyright 2017 Victor Norgren
 * Released under the MIT license
 */
var SHA256 = function () {
    function SHA256() {
        _classCallCheck(this, SHA256);
    }

    _createClass(SHA256, null, [{
        key: 'hash',
        value: function hash(string) {
            return SHA256.stringToHex(SHA256.arrayToString(SHA256.run(SHA256.stringToArray(string), string.length * 8)));
        }
    }, {
        key: 'run',
        value: function run(input, len) {
            var K = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298];
            var l = (len + 64 >> 9 << 4) + 15;
            var W = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

            var i = 0,
                H0 = 1779033703,
                H1 = -1150833019,
                H2 = 1013904242,
                H3 = -1521486534,
                H4 = 1359893119,
                H5 = -1694144372,
                H6 = 528734635,
                H7 = 1541459225,
                a = H0,
                b = H1,
                c = H2,
                d = H3,
                e = H4,
                f = H5,
                g = H6,
                h = H7;

            input[len >> 5] |= 0x80 << 24 - len % 32;
            input[l] = len;

            for (; i < l; i += 16) {
                H0 = a;
                H1 = b;
                H2 = c;
                H3 = d;
                H4 = e;
                H5 = f;
                H6 = g;
                H7 = h;

                var j = 0,
                    T1 = null,
                    T2 = null;

                for (; j < 64; j += 1) {
                    if (j < 16) {
                        W[j] = input[j + i];
                    } else {
                        W[j] = SHA256.add(SHA256.add(SHA256.add(SHA256.gamma1256(W[j - 2]), W[j - 7]), SHA256.gamma0256(W[j - 15])), W[j - 16]);
                    }

                    T1 = SHA256.add(SHA256.add(SHA256.add(SHA256.add(h, SHA256.sigma1256(e)), SHA256.ch(e, f, g)), K[j]), W[j]);
                    T2 = SHA256.add(SHA256.sigma0256(a), SHA256.maj(a, b, c));
                    h = g;
                    g = f;
                    f = e;
                    e = SHA256.add(d, T1);
                    d = c;
                    c = b;
                    b = a;
                    a = SHA256.add(T1, T2);
                }

                a = SHA256.add(a, H0);
                b = SHA256.add(b, H1);
                c = SHA256.add(c, H2);
                d = SHA256.add(d, H3);
                e = SHA256.add(e, H4);
                f = SHA256.add(f, H5);
                g = SHA256.add(g, H6);
                h = SHA256.add(h, H7);
            }
            return [a, b, c, d, e, f, g, h];
        }
    }, {
        key: 'arrayToString',
        value: function arrayToString(input) {
            var l = input.length * 32;
            var i = 0,
                output = '';

            for (; i < l; i += 8) {
                output += String.fromCharCode(input[i >> 5] >>> 24 - i % 32 & 0xFF);
            }
            return output;
        }
    }, {
        key: 'stringToArray',
        value: function stringToArray(input) {
            var l = input.length * 8;
            var output = Array(input.length >> 2);
            var lo = output.length;
            var i = 0;

            for (; i < lo; i += 1) {
                output[i] = 0;
            }
            for (i = 0; i < l; i += 8) {
                output[i >> 5] |= (input.charCodeAt(i / 8) & 0xFF) << 24 - i % 32;
            }
            return output;
        }
    }, {
        key: 'stringToHex',
        value: function stringToHex(input) {
            var hex = '0123456789abcdef';
            var l = input.length;
            var output = '',
                x = null,
                i = 0;

            for (; i < l; i += 1) {
                x = input.charCodeAt(i);
                output += hex.charAt(x >>> 4 & 0x0F) + hex.charAt(x & 0x0F);
            }
            return output;
        }
    }, {
        key: 'rotl',
        value: function rotl(X, n) {
            return X >>> n | X << 32 - n;
        }
    }, {
        key: 'rotr',
        value: function rotr(X, n) {
            return X >>> n;
        }
    }, {
        key: 'ch',
        value: function ch(x, y, z) {
            return x & y ^ ~x & z;
        }
    }, {
        key: 'maj',
        value: function maj(x, y, z) {
            return x & y ^ x & z ^ y & z;
        }
    }, {
        key: 'sigma0256',
        value: function sigma0256(x) {
            return SHA256.rotl(x, 2) ^ SHA256.rotl(x, 13) ^ SHA256.rotl(x, 22);
        }
    }, {
        key: 'sigma1256',
        value: function sigma1256(x) {
            return SHA256.rotl(x, 6) ^ SHA256.rotl(x, 11) ^ SHA256.rotl(x, 25);
        }
    }, {
        key: 'gamma0256',
        value: function gamma0256(x) {
            return SHA256.rotl(x, 7) ^ SHA256.rotl(x, 18) ^ SHA256.rotr(x, 3);
        }
    }, {
        key: 'gamma1256',
        value: function gamma1256(x) {
            return SHA256.rotl(x, 17) ^ SHA256.rotl(x, 19) ^ SHA256.rotr(x, 10);
        }
    }, {
        key: 'add',
        value: function add(x, y) {
            var lsw = (x & 0xFFFF) + (y & 0xFFFF),
                msw = (x >> 16) + (y >> 16) + (lsw >> 16);
            return msw << 16 | lsw & 0xFFFF;
        }
    }]);

    return SHA256;
}();

exports.default = SHA256;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(0);


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// sha256-es.min.js